export const replaceSlashesWithBackSlashes = (string) => string.replace(/\//g, "\\")
